// Import Swiper and its modules
import Swiper from 'swiper';
import { Autoplay, EffectFade, Navigation } from 'swiper/modules';
import forms from '../modules/Forms/forms';
import simulationOneForm from '../modules/Utils/simulation_one_form';
import videoThumbDepoimento from '../modules/Utils/video_thumb_depoimento';

videoThumbDepoimento();

// Navigation handlers
function handlePrevClick(swiper) {
    if (!swiper) {
      console.warn('Swiper is not initialized yet');
      return;
    }
    console.log('Previous button clicked');
    swiper.slidePrev();
    console.log('Current slide:', swiper.activeIndex);
  }

function handleNextClick(swiper) {
  if (!swiper) {
    console.warn('Swiper is not initialized yet');
    return;
  }
  console.log('Next button clicked');
  swiper.slideNext();
  console.log('Current slide:', swiper.activeIndex);
}

// Initialize Swiper
let swiperInstance = null;

document.addEventListener('DOMContentLoaded', () => {
  console.log('Initializing banner slider');

  // Initialize Swiper
  swiperInstance = new Swiper('.banner__slider', {
      modules: [Autoplay, EffectFade, Navigation], // Use the imported modules directly
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      speed: 1000,
      autoplay: false,
      effect: 'fade',
      fadeEffect: {
          crossFade: true
      },
      navigation: {
          prevEl: '.banner__nav--prev',
          nextEl: '.banner__nav--next',
      },
      on: {
          init: (sw) => {
              console.log('Swiper initialized successfully');
          },
          slideChange: () => {
              console.log('Slide changed to:', swiperInstance?.activeIndex);
          }
      }
  });

  // Event listeners
  if (swiperInstance) {
    document.querySelector('.banner__nav--prev').addEventListener('click', () => handlePrevClick(swiperInstance));
    document.querySelector('.banner__nav--next').addEventListener('click', () => handleNextClick(swiperInstance));
  }

  // Custom slider initialization
  const customSlider = new Swiper('.custom-slider', {
    modules: [Navigation, Autoplay],
    slidesPerView: 3,
    spaceBetween: 24,
    // loop: true,
    speed: 800,
    freeMode: true,
    // centeredSlides: true,
    // centeredSlidesBounds: true,
    autoplay: {
      delay: 100000,
      disableOnInteraction: false,
    },
    navigation: {
      prevEl: '.custom-slider__nav--prev',
      nextEl: '.custom-slider__nav--next',
    },
    breakpoints: {
      0: {
        slidesPerView: 1.15,
        spaceBetween: 16,
        centeredSlides: false,
        centeredSlidesBounds: false,
        freeMode: false,
        loop: true,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 16,
        loop: false
      },
      1024: {
        slidesPerView: 3.2,
        spaceBetween: 24,
        centeredSlides: false,
        centeredSlidesBounds: false,
        freeMode: false,
        loop: false
      },
    },
  });

  // Blog slider initialization (mobile only)
  const blogSlider = new Swiper('.blog__slider', {
    modules: [Navigation],
    slidesPerView: 1,
    spaceBetween: 16,
    loop: false,
    centeredSlides: true,
    centeredSlidesBounds: true,
    speed: 800,
    navigation: {
      prevEl: '.blog__nav--prev',
      nextEl: '.blog__nav--next',
    },
    breakpoints: {
      993: {
        enabled: false, // Disable swiper on desktop
      },
    },
  });
});

var videoLightbox = GLightbox({
    selector: '.glightbox-home',
    touchNavigation: true,
    loop: false,
    autoplayVideos: true
});

var videoLightbox = GLightbox({
  selector: '.glightbox-unity',
  touchNavigation: true,
  loop: false,
  autoplayVideos: true
});

function adjustZoom() {
  const width = window.innerWidth;
  const body = document.body;
  let isNotebook = width >= 992 && width <= 1500;

  if (isNotebook) {
    console.log("isNotebook TRUE: ", isNotebook)
    body.style.zoom = '0.9';
  } else {
    console.log("isNotebook FALSE: ", isNotebook)
    body.style.zoom = '1';
  }
}

document.addEventListener('DOMContentLoaded', function() {
  adjustZoom();
})

window.addEventListener('resize', adjustZoom);


simulationOneForm();
forms();